package ru.arty_bikini.crm.dto.packet.auth

import kotlinx.serialization.Serializable
import ru.arty_bikini.crm.dto.UserDTO
import ru.arty_bikini.crm.dto.packet.BaseResponse

//ответ для:точка входа по логину и паролю(
@Serializable
class LoginResponse(
    override val statusCode : String,
    override val ok : Boolean,
    override val displayMessage : String?,
    
    val user : UserDTO? = null,
    val accessCode: String? = null
) : BaseResponse()